export default __webpack_public_path__ + "static/media/play.45abc568.svg";